<template lang="pug">
  v-card
    crud-data-table( no-data-text="Sin cheques por cobrar." no-remove noDetail  v-bind='tableProps'  noSearch ref="table" 
        remind-key='sale-check-pending-list'
      )
      template( slot='actions' slot-scope="props")
                v-btn(
                  v-if="(props.item.sl_check_status_id ===1 || props.item.sl_check_status_id === null) && $can('EXECUTE_CHANGE_CHECK_PAYMENT_STATUS')"
                  color='success'
                  flat
                  icon
                  @click='showDialog(props)'
                  )
                    v-icon refresh
    v-dialog(v-model="dialog" persistent="" max-width="600px")
      v-card
        v-card-title
          span.headline Cambiar Estado Cheque
        v-card-text
          v-container(grid-list-md="")
            v-layout(wrap="")
              v-flex(xs12="" sm12="")
                v-autocomplete(:items="states" item-text="text" item-value="id" label="Estado" v-model="selectedStatus")
        v-card-actions
          v-spacer
          v-btn(color="blue darken-1" flat="" @click="dialog = false") Cerrar
          v-btn(color="blue darken-1" flat="" @click="submitState") Guardar
</template>

<script>
import { mapActions } from "vuex"
import { CrudCreateButton } from "@/components/reusable_components"
import { ModelDataTable } from "@/components/reusable_components/next"
//
import SnackbarModalUtils from "@/mixins/reusable_mixins/SnackbarModalUtils"
import CheckModel from "@/models/Sale/SlCheck"
//
import CheckFilters from "@/views/Sale/SlCheck/partials/CheckFilters"
import CheckHeaders from "@/views/Sale/SlCheck/partials/CheckHeaders"
import SlCheckHeaders from "@/views/Sale/SlCheck/SlCheckHeaders"
//
export default {
  beforeMount () {
      //
      this.setTitleTopBar( "Cheques por Cobrar" )

        //
        //CheckModel.appends = [...checkService.appends]

        //
        //CheckModel.includes = [...checkService.includes]
    },
    components: {
        "crud-create-button": CrudCreateButton,
        "crud-data-table"   : ModelDataTable,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                filters: CheckFilters,
                headers: SlCheckHeaders.toList(),
                service: CheckModel,
                paramFilter: {
                    sl_check_status_id: 1,
                },
            }
        },
        /*
         */
        formProps(){
          return {
              noButtons: true,
              ref: "checkForm",
          }
        },
        /*
         */
        states () {
          return [
            {
              id:1,
              text:"Pendiente"
            },
            {
              id:2,
              text: "Cobrado"
            },
            {
              id:3,
              text: "Rechazado"
            }
          ]
          
        }
    },
    data() {
        return {
            dialog : false,
            selectedStatus:null,
            checkSelectedId:null,
            checkMdl : CheckModel,            
        }
    },
    methods: {
        /**
          * 
          */
        ...mapActions("MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),
        /*
         */
        ...mapActions("SnackbarModalModule", {
            initSnackbar: "initSnackbar",
            hideSnack: "hideSnack",
            resetSnackbarState: "resetSnackbarState",
            setMessageConfirmSnack: "setMessageConfirmSnack",
        }),
        /*
         */
        setStatus(id) {
            this.selectedStatus = id
        },
        /*
         */
        setDialog(val) {
            this.dialog = val
        },
        /*
         */
        setCheckId(id) {
            this.checkSelectedId = id
        },
        /*
         */
        showDialog(event) {
            if (event.item.sl_check_status_id) {
                this.setStatus(event.item.sl_check_status_id)
            } else {
                const pendiente = 1
                this.setStatus(pendiente)
            }
            this.setCheckId(event.item.id)
            this.setDialog(true)
        },
        /*
         */
        async submitState(){
          let model = this.checkMdl
          let check = new model()
          let data ={
            sl_check_status_id : this.selectedStatus
          }
          let resp = await check.updateStatus(this.checkSelectedId,data)
          //console.log(resp.status,"resp")
          if(this.snackResponseSubmit(resp,"Estado Cheque Actualizado")){
            this.setDialog(false)
            this.$refs.table.refresh()        
          }
        },
    },
    mixins: [SnackbarModalUtils],
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_CHECK_PAYMENT')) ctx.$router.push('/')
        })
    },
}
</script>
